import { render, staticRenderFns } from "./EditTemplate.vue?vue&type=template&id=50a07f12&"
import script from "./EditTemplate.vue?vue&type=script&lang=ts&"
export * from "./EditTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports